// Helpers for the subtle duration warning shown in the tour itinerary. All
// durations are in minutes.

interface DurationSegment {
  duration?: unknown
}

export const DURATION_WARNING = {
  // Segments have real durations but the tour's overall duration is unset (0).
  unsetTourDuration: "unset_tour_duration",
  // Segments have durations that don't sum to the (set) tour duration.
  mismatch: "mismatch",
} as const

export type DurationWarning = (typeof DURATION_WARNING)[keyof typeof DURATION_WARNING] | null

export const sumSegmentDurations = (segments: DurationSegment[]): number =>
  segments.reduce((total, segment) => total + (Number(segment.duration) || 0), 0)

// Which duration warning (if any) to show for the current segments and tour
// duration. Stays silent on a half-filled tour: no segments, or segments with no
// durations and no tour duration to compare against.
export const segmentDurationWarning = (
  segments: DurationSegment[],
  tourDuration: number
): DurationWarning => {
  if (segments.length === 0) {
    return null
  }

  const total = sumSegmentDurations(segments)

  if (tourDuration === 0) {
    return total > 0 ? DURATION_WARNING.unsetTourDuration : null
  }

  return total === tourDuration ? null : DURATION_WARNING.mismatch
}
